var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99984 2.5C10.9203 2.5 11.6665 3.24619 11.6665 4.16667C11.6665 5.08714 10.9203 5.83333 9.99984 5.83333C9.07936 5.83333 8.33317 5.08714 8.33317 4.16667C8.33317 3.24619 9.07936 2.5 9.99984 2.5ZM9.99984 8.33333C10.9203 8.33333 11.6665 9.07953 11.6665 10C11.6665 10.9205 10.9203 11.6667 9.99984 11.6667C9.07936 11.6667 8.33317 10.9205 8.33317 10C8.33317 9.07953 9.07936 8.33333 9.99984 8.33333ZM9.99984 14.1667C10.9203 14.1667 11.6665 14.9129 11.6665 15.8333C11.6665 16.7538 10.9203 17.5 9.99984 17.5C9.07936 17.5 8.33317 16.7538 8.33317 15.8333C8.33317 14.9129 9.07936 14.1667 9.99984 14.1667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsVertical);
export default __webpack_public_path__ + "static/media/dots-vertical.53f814b9227683a225e1223adf08e3f9.svg";
export { ForwardRef as ReactComponent };